// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__hgSp0"};